import { useEffect, useRef } from "react";

/**
 * @description
 * input がレンダリングされた際に input に focus を当てるための hooks
 */
export const useFocusToInput = () => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return inputRef;
};
